<template>
  <div class="c_page">
    <div class="banner">
      <p class="banner_text">今日获得<img src="../../images/yuanbao.png" class="yuanbao" /><span class="yellow">59</span>券币</p>
    </div>
    <div class="list_wrapper">
      <div class="list bbline">
        <div class="lsit_l">
          <img src="../../images/yuanbao_circle.png" class="yuanbao_circle" />
        </div>
        <div class="list_c">
          <p class="list_title">每日签到</p>
          <p class="list_des">每次签到可获得券币</p>
          <p class="list_des">每日上限1次</p>
        </div>
        <div class="lsit_r">
            <p class="add_score">＋5</p>
            <p class="signin aready">已签到</p>
        </div>
      </div>
      <div class="list bbline">
        <div class="lsit_l">
          <img src="../../images/yuanbao_circle.png" class="yuanbao_circle" />
        </div>
        <div class="list_c">
          <p class="list_title">每日签到</p>
          <p class="list_des">每次签到可获得券币</p>
          <p class="list_des">每日上限1次</p>
        </div>
        <div class="lsit_r">
            <p class="add_score">＋5</p>
            <p class="signin noaready">前往</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecamscript-6">
  export default{
    name:"getCoinsWays"
  }
</script>
<style lang="stylus">
  .c_page
    .banner
      width:750px
      height:179px
      background:url("../../images/coins_ways_bg.jpg")no-repeat left top
      background-size:750px 179px
      padding-top:115px
      box-sizing:border-box
      .banner_text
        font-size:24px
        color:#fff
        text-align:center
        .yuanbao
          width:45px
          height:27px
          vertical-align:middle
          margin:0 10px
        .yellow
          color:#ffe346
    .list
      padding:30px 40px
      background:#fff
      box-sizing:border-box
      display:flex
      align-items:center
      .lsit_l
        flex:0 0 130px
        .yuanbao_circle
          width:88px
          height:88px
          display:block
      .list_c
        flex:1
        padding-right:50px
        .list_title
          font-size:30px
          color:#333
          margin-bottom:5px
        .list_des
          font-size:24px
          color:#808080
          line-height:36px
      .lsit_r
        flex:0 0 130px
        text-align:center
        .add_score
          font-size:30px
          color:#ff8400
        .signin
          width:130px
          height:56px
          border-radius:28px
          line-height:56px
          font-size:30px
          margin-top:10px
          &.aready
            color:#ff3f34
          &.noaready
            color:#fff
            background:#ff3126
</style>



// WEBPACK FOOTER //
// src/components/userCenter/getCoinsWays.vue